import trimEnd from 'lodash/trimEnd';
import trimStart from 'lodash/trimStart';

export const buildPublicUrl = (path: string): string => {
    const publicUrl = trimEnd(process.env.PUBLIC_URL || '/', '/');

    if (!publicUrl) {
        return `/${trimStart(path, '/')}`;
    }

    return `${publicUrl}/${trimStart(path, '/')}`;
};

export const buildRelativeUrl = (path: string): string => {
    const basename = trimEnd(process.env.REACT_APP_BASE_PATHNAME || '/', '/');

    if (!basename) {
        return `/${trimStart(path, '/')}`;
    }

    return `${basename}/${trimStart(path, '/')}`;
};
